module.exports = __webpack_public_path__ + "assets/media/chat-with-bot.9375f3ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/OnboardingPlaybookPickBotStep/chat-with-bot.svg
// module id = 2976
// module chunks = 0